import React, { useEffect, useState, useRef } from "react";
import {
  Stack,
  Typography,
  Button,
  Modal,
  Fade,
  Box,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import {
  esignAPICall,
  stageDetailsAPICall,
  CreatePdfEsignAPICall,
  CreateEsignRequestAPICall,
} from "../shared/APICalls";
import routesData from "../shared/routes.json";
import ESignStyles from "../pages/Styles/Esign.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import SnackBar from "../Components/SnackBars/SnackBar";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import esignImage from "../Components/assets/Images/EsignImage.jpg";
import PDFViewerIframeEsign from "../Components/PDFIframe/PDFIframeEsign";
import keyboardicon from "../Components/assets/Images/sigicon.svg";
import backicon from "../Components/assets/Images/back.svg";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import TagManager from "react-gtm-module";
import ProgressComp from "../Components/ProgressComp/ProgressComp";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "90vH",

  borderRadius: "20px",
  boxShadow: 24,
  padding: "10px 0px 0px 5px",
};

export default function EsignPage() {
  const dispatch = useDispatch();
  const [childWindowRef, setchildWindowRef] = useState<any>(null);
  const [closetTimer, setclosetTimer] = useState(false);
  const [loading, setloading] = useState(false);
  const [startOverloading, setstartOverloading] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [showModal, setshowModal] = useState(true);
  const [pdfUrl, setPdfUrl] = useState<any>("");
  const [continueOption, setcontinueOption] = useState(true);
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [continueEsignLoading, setcontinueEsignLoading] = useState(false);
  const [startloading, setstartloading] = useState(false);
  const [agentPlatform, setAgentPlatform] = useState("");

  const navigationData = routesData;
  const [ErrorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const timerRef = useRef<any>(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    checkUserLoggedIn(navigate);
    setloading(true);
    let obj: any = {
      stage: "esign",
    };
    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setloading(false);
        dispatch(setCompletedStages(responseData.data.completed_stages));
        dispatch(setCurrentStage(responseData.data.current_stage));

        if (responseData.data.ErrorMessage) {
          setRejectMessage(responseData.data.ErrorMessage);
        }

        if (
          responseData.data.data.url &&
          responseData.data.ErrorMessage === ""
        ) {
          setcontinueOption(false);

          setPdfUrl(responseData.data.data.url);
          if (
            responseData?.data?.next_stage &&
            navigationData.hasOwnProperty(responseData?.data?.next_stage)
          ) {
            navigate(navigationData[responseData?.data?.next_stage]);
          }
        }
      })
      .catch((error: any) => {
        //  console.log("error", error);
      });
    GenerateEsignPdf();

    const userAgent = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(userAgent)) {
      setAgentPlatform("iOS");
    } else if (/android/.test(userAgent)) {
      setAgentPlatform("Android");
    } else {
      setAgentPlatform("Other");
    }
  }, []);
  useEffect(() => {
    if (startloading) {
      setloading(true);
      if (pdfUrl) {
        setshowModal(true);
        setloading(false);
        setstartloading(false);
      }
    }
  }, [pdfUrl, startloading]);
  useEffect(() => {
    if (!closetTimer && childWindowRef) {
      //  console.log("timer trigger");
      timerRef.current = setInterval(checkChild, 500);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [childWindowRef, closetTimer]);

  const GenerateEsignPdf = () => {
    // setloading(true);
    CreatePdfEsignAPICall()
      .then((response: any) => {
        const responseData = response?.data?.data?.url;
        // console.log("responseData", responseData);
        setPdfUrl(response?.data?.data?.url ? response.data.data.url : "");
        // setloading(false);
      })
      .catch((error: any) => {
        setErrorMessage(error?.response?.data?.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
        // setloading(false);
      });
  };

  const handleEsignNow = () => {
    if (pdfUrl) {
      setshowModal(true);
      setloading(false);
    } else {
      handleEsignNow();
    }
  };

  const openHtmlPage = (htmlString: string) => {
  const blob = new Blob([htmlString], { type: "text/html" });
  const url = URL.createObjectURL(blob);

  window.location.href = url;
};

  const handleOpenClick = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitEsign",
      },
    });

    let digilink: string = "";
    setcontinueEsignLoading(true);
    CreateEsignRequestAPICall()
      .then((response: any) => {
        const responseData = response?.data;

        // console.log("responseData", responseData.data);

        var url = responseData?.data?.esp_html;
        var trimmedUrl = url.replace(":444", "");
        digilink = url;
        // if (agentPlatform === "iOS") {

        openHtmlPage(digilink)
        // window.location.href = digilink;
        // } else {
        //   const childWindow: any = window.open(
        //     digilink,
        //     "_blank",
        //     "width=500,height=700"
        //   );
        //   setchildWindowRef(childWindow);
        // }

        // setcontinueEsignLoading(false);
      })
      .catch((error: any) => {
        setloading(false);
        setcontinueEsignLoading(false);
        setErrorMessage(
          error?.message?.includes("Network")
            ? "Error occured, Please try again"
            : error?.response?.data?.message,
        );
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      });
  };
  const handleContinue = () => {
    setOpen(false);
    setloading(false);
  };

  function eSign() {
    setloading(true);
    esignAPICall()
      .then((response: any) => {
        const responseData = response?.data;
        // console.log("responseData", response);
        setloading(false);

        if (
          responseData?.data?.stage &&
          navigationData.hasOwnProperty(responseData?.data?.stage)
        ) {
          navigate(navigationData[responseData?.data?.stage]);
        }
      })
      .catch((error: any) => {
        //  console.log("error", error);
        setloading(false);
      });
  }

  function checkChild() {
    // console.log("timer");

    if (childWindowRef && childWindowRef.closed) {
      clearInterval(timerRef.current);

      let obj: any = {
        stage: "esign",
      };

      stageDetailsAPICall(obj)
        .then((response: any) => {
          const responseData = response?.data;
          setloading(false);
          if (responseData?.data?.data?.url) {
            navigate("/congratulations");
            setloading(true);
          }

          setPdfUrl(responseData?.data?.data?.url);
          setloading(false);
        })
        .catch((error: any) => {
          //  console.log("error", error);
        });
    }
  }

  const handlePreviewClick = () => {
    setshowModal(true);
  };

  return (
    <>
      {/* <div className={ESignStyles.step}>
        <img
          src={keyboardicon}
          style={{
            filter: "grayscale(0.95) invert(0.1) brightness(1)",
          }}
        />{" "}
        Step 4 of 4
      </div> */}
      <ProgressComp />
      <div className={ESignStyles.mainWrapperTop}>
        <SnackBar message={ErrorMessage} />
        <ErrorSnackBar message={rejectMessage} />

        <div className={ESignStyles.wrapper}>
          <div
            className={ESignStyles.back}
            onClick={() => {
              // if (showModal) {
              //   setshowModal(false);
              // } else {
                navigate("/nominee");
              // }
            }}
          >
            <img src={backicon} />{" "}
            <span className={ESignStyles.backText}>Back</span>
          </div>
          {showModal ? (
            <p className={ESignStyles.almostThereText}>Esign Preview</p>
          ) : (
            // <div className={ESignStyles.step}>
            //   <img src={keyboardicon} /> Step 10 of 10
            // </div>
            ""
          )}
          {showModal ? (
            ""
          ) : (
            <div className={ESignStyles.titleSection}>
              <p className={ESignStyles.almostThereText}>Almost There!</p>
              <p className={ESignStyles.title}>
                {" "}
                Digitally sign your application
              </p>
            </div>
          )}
          {!showModal ? (
            <div className={ESignStyles.container}>
              <div className={ESignStyles.leftcontainer}>
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <div className={ESignStyles.textdiv}>
                    <p className={ESignStyles.instructiontext}>
                      <DoneOutlinedIcon style={{ color: "#049981" }} /> Click on
                      the E-Sign Button Below.
                    </p>
                    <p className={ESignStyles.instructiontext}>
                      <DoneOutlinedIcon style={{ color: "#049981" }} /> Enter
                      Your Aadhaar Number.
                    </p>
                    <p className={ESignStyles.instructiontext}>
                      <DoneOutlinedIcon style={{ color: "#049981" }} /> Enter
                      the OTP sent to your registered mobile number.
                    </p>
                  </div>
                  <div>
                    <>
                      <div className={ESignStyles.buttonStyles}>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {continueOption ? (
                            <LoadingButton
                              type="submit"
                              variant="contained"
                              onClick={() => {
                                setstartloading(true);
                              }}
                              loading={loading}
                              id="aadharOpenLinkButton"
                              className={ESignStyles.esignButton}
                              sx={{ width: "187px", height: "50px" }}
                            >
                              Esign Now
                            </LoadingButton>
                          ) : (
                            <>
                              <div className={ESignStyles.sectionButton}>
                                <LoadingButton
                                  className={ESignStyles.esignButton}
                                  type="submit"
                                  variant="contained"
                                  sx={{ width: "187px", height: "50px" }}
                                  onClick={handleContinue}
                                  loading={loading}
                                  id="aadharOpenLinkButton"
                                >
                                  Continue
                                </LoadingButton>
                                <Button
                                  className={ESignStyles.esignPreview}
                                  type="submit"
                                  variant="outlined"
                                  sx={{
                                    color: "#1F2937",
                                    marginLeft: "10px",
                                    height: "50px",
                                  }}
                                  onClick={handlePreviewClick}
                                  id="aadharOpenLinkButton"
                                >
                                  View E-sign Document
                                </Button>
                              </div>
                            </>
                          )}
                        </div>
                        {backdrop && <StartOverBackDrop />}
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={ESignStyles.modalContainer}>
              <div className={ESignStyles.pdfMobilePreview}>
                <img
                  src={esignImage}
                  style={{
                    width: "95%",
                    height: "60%",
                    objectFit: "inherit",
                    // filter: "brightness(80%)",
                    border: "5px solid #525659",
                    marginBottom: "20px",
                  }}
                />

                {/* <a
                href={pdfUrl}
                download="Esign-PDF-document"
                target="_blank"
                rel="noreferrer"
                className={ESignStyles.previewdownlaodesign}
              >
                <Button
                  variant="contained"
                  sx={{
                    background: "#1976d2",
                    "&:hover": { background: "#1976d2" },
                  }}
                >
                  View Esign Document
                </Button>
              </a> */}
              </div>
              <div className={ESignStyles.pdfDesktopPreview}>
                {pdfUrl ? (
                  <PDFViewerIframeEsign urldata={pdfUrl} />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      minHeight: "400px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border:"1px solid #525659",
                      background:"#525659"
                    }}
                  >
                    <CircularProgress  style={{color:"#fff"}}/>
                  </div>
                )}
              </div>
              <div className={ESignStyles.buttonStylesBottom}>
                <a
                  href={pdfUrl}
                  download="Esign-PDF-document"
                  target="_blank"
                  rel="noreferrer"
                  className={ESignStyles.previewdownlaodesign}
                >
                  <Button
                    variant="outlined"
                    sx={{
                      color: "#1F2937",
                      height: "50px",
                      background: "#fff",
                      width: "100%",
                      border: "1px solid #E5E7EB",
                    }}
                  >
                    View Esign PDF
                  </Button>
                </a>
                <LoadingButton
                  loading={continueEsignLoading}
                  variant="contained"
                  sx={{
                    width: { xs: "100%", sm: "187px" },
                    margin: "auto",
                    height: { xs: "60px", sm: "50px" },
                  }}
                  onClick={handleOpenClick}
                >
                  Continue
                </LoadingButton>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
